import { ResearchMunicipalityForm } from 'civil-status/view-models/research-municipality';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const researchMunicipalityInitialValues: ResearchMunicipalityForm = {
  orders: {},
  page: 0,
  description: '',
  id: '',
  rowsPerPage: 10,
};

const ResearchMunicipalityInitializer = (): React.ReactElement => {
  return (
    <FilterTableProvider initialValues={researchMunicipalityInitialValues}>
      <Outlet />
    </FilterTableProvider>
  );
};

ResearchMunicipalityInitializer.displayName = 'Research Municipality initializer component';

export default ResearchMunicipalityInitializer;
